<template>
    <main-content with_go_back_bar>
        <add-category v-if="$can('manage-user-category', 'user')" :action="addCategory"></add-category>
        <categories-filter :action="filterAction"></categories-filter>
        <div class="switch-div">
            همه دسته ها
            <label class="switch m-0 mr-2 ml-2">
                <input id="category_checkbox" type="checkbox" @change="checkbox_changed">
                <span class="slider round"></span>
            </label>
            دسته هایی که کاربر دارند
        </div>
        <kt-datatable v-bind="datatableProps" ref="datatable"></kt-datatable>
    </main-content>
</template>

<script>

import mainContent from "@/components/main-content";
import CategoriesFilter from "./components/filter-categories"
import addCategory from "./components/add-category"
import {ApiUrl, userService} from "@/common/api.service";
import {AuthorizationHeader} from "@/common/jwt.service";
import columns from "./datatable/categories-columns";
import actionsColumn  from "@/views/user-categories/components/categories-actions-column";
import toastr from "toastr";
import $ from "jquery";
import {KTApp} from "@/plugins/core/app";
import Vue from "vue";
import {KTUtil} from "@/plugins/core/util";
import {i18n} from "@/plugins/i18n";

export default {
    components: {
        'main-content': mainContent,
        'categories-filter': CategoriesFilter,
        'add-category': addCategory

    },
    data() {
        return {
            query: {
                show_all_categories: 0
            }
        }
    },
    computed: {
        datatableProps() {
            return {
                id: "categories_datatable",
                data: {
                    type: "remote",
                    source: {
                        read: {
                            url: ApiUrl.path("user/categories"),
                            method: "GET",
                            headers: AuthorizationHeader,
                            map: function (res) {
                                return res.data.data;
                            },
                            params: {
                                query: this.query,
                            },
                        },
                    },
                    pageSize: 10,
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                },
                layout: {},
                pagination: false,
                sortable: true,
                columns: columns,
                actions: actionsColumn,
            };
        },
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: true,
                rtl: false
            }

            return toastr
        }
    },
    methods: {
        filterAction(e, query) {
            this.query = query;
            if (this.$refs.datatable.KTDatatable) {
                this.$refs.datatable.reload();
            }
        },
        addCategory(e, params) {
            let form = $(e.target)
            let btn = $('#submit_btn')

            form.validate({
                ignore: ":hidden",

                rules: {
                    cat_name : {
                        required: true,
                    }
                },
            });

            if(!form.valid()) {
                return
            }

            KTApp.progress(btn)
            userService.addCategory(params)
                .then(response => {
                    this.toastr.success(response.data.message)
                })
                .catch(({response}) => {
                    this.toastr.error(i18n.t('message.an_error_accord'))
                })
                .finally(() => {
                    KTApp.unprogress(btn)
                    if (this.$refs.datatable.KTDatatable) {
                        this.$refs.datatable.reload();
                    }
                })
        },
        checkbox_changed(e) {
            let checkbox = $('#category_checkbox')

            if (checkbox.is(":checked"))
                this.query.show_all_categories = 1
            else
                this.query.show_all_categories = 0

            if (this.$refs.datatable.KTDatatable) {
                this.$refs.datatable.reload()
            }
        }
    }
}
</script>

<style scoped>
.switch-div {
    width: fit-content;
    padding: 8px 27px;
    background: #fff;
    box-shadow: 0 0 7px 0 #9c9c9c5e;
}
.switch {
    position: relative;
    display: inline-block;
    width: 60px;
    height: 20px;
}

/* Hide default HTML checkbox */
.switch input {
    opacity: 0;
    width: 0;
    height: 0;
}

/* The slider */
.slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #6aad27;
    -webkit-transition: .4s;
    transition: .4s;
}

.slider:before {
    position: absolute;
    content: "";
    height: 12px;
    width: 26px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    -webkit-transition: .4s;
    transition: .4s;
}

input:checked + .slider {
    background-color: #2196F3;
}

input:focus + .slider {
    box-shadow: 0 0 1px #2196F3;
}

input:checked + .slider:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
}
.slider.round {
    border-radius: 50px;
}

.slider.round:before {
    border-radius: 50px;
}

.info-icon {
    cursor: pointer;
    color: #0f9af0;
    display: inline-block;
}
</style>